<template>
  <div class="home">
    <Hero />
    <SleepList />
  </div>
</template>

<script>
// @ is an alias to /src
import Hero from "@/components/home/Hero.vue";
import SleepList from "@/components/home/SleepList.vue";

export default {
  name: "home",
  components: {
    Hero,
    SleepList
  },

  metaInfo: {
    title: 'Slumber Bear - Find Your Sleep Schedule',
    // override the parent template and just use the above title only
    titleTemplate: null
  },


};
</script>
